import React from 'react';
import TwoColumns from '../../components/structures/gpm/detail-page/TwoColumns';
import InterestedBlock from '../../components/structures/gpm/InterestedBlock';
import { fulfillment, fulfilmentGlobe } from '../../images/gpm';
import ImpactBlock from '../../components/structures/gpm/detail-page/ImpactBlock';
import HowItWorks from '../../components/structures/gpm/detail-page/HowItWorks';

const heroData = [
  { boldText: 'Subcontractor Task & Progress Management', text: 'Assign, monitor, and verify field operations.' },
  { boldText: 'Quality Control & Self-QC Reporting', text: 'Reduce rework with automated field validations.' },
  { boldText: 'Real-Time Subcontractor Reporting', text: 'Capture proof of completed tasks, photos, and QC submissions.' },
  { boldText: 'Transparent, Proof-Based Billing', text: 'Link invoices directly to verified work and prevent overbilling.' },
];

const impactData = [
  { boldText: '99%', text: 'billing accuracy' },
  { boldText: '80%', text: 'reduction in manual intervention' },
  { boldText: 'Millions', text: 'saved on billing error prevention' },
];

const FulfillmentServices = () => {
  return (
    <>
      <TwoColumns
        title={'Fulfillment Services & Subcontractor Management'}
        list={heroData}
        image={fulfillment}
        subtitle={
          'For large-scale fulfillment and subcontractor operations, GPM brings order to complexity. It enables telecom providers to monitor dispatches, track installs, and validate work performed through structured workflows and real-time mobile reporting.'
        }
      />
      <HowItWorks
        description={
          'Technicians and contractors use GPM to log completed tasks, upload media, and sync directly to centralized records. Supervisors gain total visibility into technician movements, asset usage, and status of multi-location deployments.'
        }
        image={fulfilmentGlobe}
      />
      <ImpactBlock
        title={'Impact'}
        description={'Here are three key ways GPM supports Fulfillment Services & Subcontractor Management:'}
        listItems={impactData}
      />
      <InterestedBlock title={'Are You Interested?'} />
    </>
  );
};

export default FulfillmentServices;
